<template>
  <div class="main-div">
    <div class="heading-name">
      <img
       v-if="logo == 'land' "
        height="20"
        width="20"
        src="../../../../assets/userDetails/landIcon.svg"
      />
      <img
      v-else-if=" logo == 'tractor' "
      height="20"
      width="20"
      src="../../../../assets/userDetails/tractorIcon.svg"
    />
    <img
    v-else-if=" logo == 'cattle' "
    height="20"
    width="20"
    src="../../../../assets/userDetails/cattleIcon.svg"
  />
      <p class="heading-text">{{heading}}</p>
    </div>
    <v-divider />
    <div class="details">
      <div class="question">
        <p>Land Ownership</p>
        <p>Land Size</p>
      </div>
      <div class="answer">
        <p>{{data.land_ownership}}</p>
        <p>{{data.land_size}}</p>
      </div>
    </div>
  </div>
</template>
    
<script>
export default {
  name: "landCard",
  props: {
    heading:String,
    logo:String,
    data:null
  },
};
</script>
<style lang="scss" scoped>
.main-div {
  height: 213px;
  width: 32%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  p {
    margin-bottom: 0px;
  }
}
.heading-name {
  height: 52px;
  margin-left: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
}
.heading-text {
  color: #3a3f3a;
  font-size: 16px;
  font-weight: 500;
}
.btn-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 24px;
}
.details {
  display: flex;
  width: 100%;
  flex-direction: row;
  margin-left:32px;
}
.question {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 50%;
  margin-top: 32px;
  p {
    color: #797e79;
    margin: 0;
  }
}
.answer {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 50%;
  margin-top: 32px;
  p {
    color: #3a3f3a;
    margin: 0;
  }
}
</style>